export const STATUS_MAP = {
    active: { color: 'var(--bs-success)', bg: 'rgba(var(--bs-success-rgb, 80, 205, 137), 0.12)' },
    expired: { color: 'var(--bs-danger)', bg: 'rgba(var(--bs-danger-rgb, 241, 65, 108), 0.12)' },
    suspended: { color: 'var(--bs-warning)', bg: 'rgba(var(--bs-warning-rgb, 255, 199, 0), 0.12)' },
};

export const MOCK_SUBSCRIPTIONS = [
    { id: 11, product_id: 12, product_name: 'Başlangıç Paketi', status: { id: 1, label: 'Aktif', class: 'active' }, starts_at: '2026-02-23 03:26:50', expires_at: '2026-03-25 03:26:50', remaining_days: 28, is_trial: false, auto_renew: true },
    { id: 8, product_id: 5, product_name: 'SMS Paketi - 1000 Kredi', status: { id: 3, label: 'Süresi Doldu', class: 'expired' }, starts_at: '2025-11-01 00:00:00', expires_at: '2026-02-01 00:00:00', remaining_days: 0, is_trial: false, auto_renew: false },
    { id: 15, product_id: 9, product_name: 'Premium Paket', status: { id: 2, label: 'Askıya Alındı', class: 'suspended' }, starts_at: '2026-02-01 00:00:00', expires_at: '2026-08-01 00:00:00', remaining_days: 157, is_trial: false, auto_renew: true },
];

export function subscriptionProgress(sub) {
    const now = new Date();
    const start = new Date(sub.starts_at);
    const end = new Date(sub.expires_at);
    const total = end - start;
    if (total <= 0) return 100;
    const elapsed = now - start;
    if (elapsed <= 0) return 0;
    if (elapsed >= total) return 100;
    return Math.round((elapsed / total) * 100);
}

export function formatSubDate(dateStr) {
    const d = new Date(dateStr);
    const months = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
}
